import React from 'react'
import { SignatureDiv, SignatureImg, SignatureText } from './style'

const Signature:React.FC = () => {
  return(
    <SignatureDiv>
      {/* <SignatureImg  
      src="https://stgploomescrmprd01.blob.core.windows.net/crm-prd/36010046466A/Images/de30cc7083c743e7a86f43e36fd61459.jpg" 
      alt="assinatura"
      draggable='false'
      /> */}
      <SignatureText>
        <span>Luna Pereira de Farias</span>
        <span>Controle de Qualidade</span>
        <span className='english'>Quality Control</span>
      </SignatureText>
    </SignatureDiv>
  )
}

export default Signature